import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'fac_failing_comply_legal_req_contracts_hiring_practices'

export const dataPointDefinition = {
  retracedId: 'fac_failing_comply_legal_req_contracts_hiring_practices',
  name: 'Is the facility failing to comply with any legal requirements for Contracts and Hiring Practices pertaining to non-produ',
  description:
    'Answer No if the facility is complying with all legal requirements on Contracts and Hiring Practices pertaining to non-production workers and/or onsite sub-contracted workers.',
  meta: {
    slcpMeta: {
      key: 'rh-emp-8',
      number: 'RH-EMP-30',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34550,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
